import { styled } from 'styled-components';

import { DeviceQueries } from 'Common/components/styled';

export const PageCard = styled.div`
  background: white;

  @media (${DeviceQueries.notMobile}) {
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    border: 1px solid #E4E7EF;
    padding: 24px;
  }
`;

export const PageTitle = styled.h1`
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 700;
  color: #1A1D2B;
  background: linear-gradient(135deg, #02033B 0%, #743D98 60%, #AC326C 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (${DeviceQueries.mobile}) {
    font-size: 22px;
    padding: 16px;
    margin: 0;
  }
`;
